import React from "react";
import Cookies from "universal-cookie";
import "../../../App.css";
import { NavLink } from "react-router-dom";
import * as RiIcons from "react-icons/ri";
import * as MdIcons from "react-icons/md";

const cookies = new Cookies();
class MOFDashboard extends React.Component {
  render() {
    const removeCookie = () => {
      cookies.remove("token");
      cookies.remove("user-type");
      window.location.href = "/";
    };

    if (
      cookies.get("token") &&
      cookies.get("user-type") &&
      cookies.get("user-type") === "4"
    ) {
      return (
        <div className="Doctor-dashboard-div">
          <div
            className="Doctor-dashboard-heading"
            style={{ color: "#9A593C" }}
          >
            <div style={{ fontSize: 56 }}>مرحباً بكَ سيد ابراهيم</div>
            <h4>..يمكنك اختيار وتنفيذ احد التقارير ادناه</h4>
          </div>
          <div className="Doctor-dashboard-options">
            {/* DASHBOARD */}
            <NavLink
              className="Doctor-dashboard-option-card"
              to="/report-dashboard-mof"
              style={{ color: "#9A593C" }}
            >
              <div style={{ width: "20%" }}>
                <RiIcons.RiArrowDropLeftLine size={100} />
              </div>
              <div style={{ width: "70%", textAlign: "right" }}>
                <h2>{
                  cookies.get('role_id')==0?
                  "لوحة التحكم":"الصفحة الرئيسية"
                }
                  </h2>
                <h6>
                  يمكنك من هذا الاختيار الاطلاع على
                  {
                  cookies.get('role_id')==0?
                  " لوحة التحكم ":" الصفحة الرئيسية "
                }</h6>
              </div>

              <div style={{ width: "20%", textAlign: "center" }}>
                <MdIcons.MdDashboard size={100} />
              </div>
            </NavLink>
            {/* DASHBOARD REPORT 1 */}
            {/* <NavLink
              className="Doctor-dashboard-option-card"
              to="/report-dashboard-mof"
              style={{ color: "#9A593C" }}
            >
              <div style={{ width: "20%" }}>
                <RiIcons.RiArrowDropLeftLine size={100} />
              </div>
              <div style={{ width: "70%", textAlign: "right" }}>
                <h2>احصائيات لوحة التحكم</h2>
                <h6>
                  يمكنك من هذا الاختيار الاطلاع على لوحة التحكم التي تحتوي اهم
                  الاحصائيات المسجلة في النظام
                </h6>
              </div>

              <div style={{ width: "20%", textAlign: "center" }}>
                <MdIcons.MdDashboard size={100} />
              </div>
            </NavLink> */}

            {/* EXCUTE REPORT 1 */}
            <NavLink
              className="Doctor-dashboard-option-card"
              to="/registered-doctors-mof"
              style={{ color: "#9A593C" }}
            >
              <div style={{ width: "20%" }}>
                <RiIcons.RiArrowDropLeftLine size={100} />
              </div>
              <div style={{ width: "70%", textAlign: "right" }}>
                <h2>تقرير الاستحصال الشهري</h2>
                <h6>
                  يمكنك من خلال هذا التقرير الاطلاع على المبلغ الكلي والمبالغ
                  الفرعية وتاريخ المعاملات المسجلة
                </h6>
              </div>

              <div style={{ width: "20%", textAlign: "center" }}>
                <RiIcons.RiMoneyDollarCircleLine size={100} />
              </div>
            </NavLink>
          </div>

          <div
            onClick={() => removeCookie()}
            className="Doctor-dashboard-footer"
            style={{ color: "#9A593C" }}
          >
            <div style={{ fontSize: 16 }}>تسجيل الخروج</div>
          </div>
        </div>
      );
    } else {
      // window.location.href = "/"
    }
  }
}

export default MOFDashboard;
